/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="M9.6494.6862c1.6093-.915 3.5919-.915 5.2012 0l6.0488 3.439C22.5087 5.0403 23.5 6.7312 23.5 8.561v6.8782c0 1.8298-.9913 3.5207-2.6006 4.4356l-6.0488 3.4391c-1.6093.9149-3.5919.9149-5.2012 0l-6.0488-3.4391C1.9913 18.9598 1 17.2689 1 15.4391V8.5609c0-1.8298.9913-3.5207 2.6006-4.4356L9.6494.6862Zm3.5948 1.5226-.0016 11.1245 3.7059-2.8c.3987-.3012.9492-.2546 1.2931.0883l.0966.1117c.2991.4017.2528.9562-.0876 1.3027l-.1109.0973-5.8897 4.45-5.8897-4.45c-.4386-.3313-.5275-.9581-.1985-1.4a.9884.9884 0 0 1 1.2659-.28l.1238.08 3.7059 2.8-.0002-11.125a3.1371 3.1371 0 0 0-.3409.1352l-.2266.117-6.049 3.439c-.9654.549-1.5602 1.5635-1.5602 2.6614v6.8782c0 1.0979.5948 2.1124 1.5603 2.6614l6.0489 3.439a3.1622 3.1622 0 0 0 3.1206 0l6.0489-3.439c.9655-.549 1.5603-1.5635 1.5603-2.6614V8.5609c0-1.0979-.5948-2.1124-1.5603-2.6614l-6.0489-3.439a3.143 3.143 0 0 0-.5661-.2517Z"
  />,
  'MenuIntegrations'
);
